export type { BonusReportTranslations } from "./bonus-report-pt-br";
export { BONUS_REPORT_PT_BR } from "./bonus-report-pt-br";
export { BONUS_REPORT_FR_FR } from "./bonus-report-fr-fr";
export { BONUS_REPORT_EN_US } from "./bonus-report-en-us";
export { BONUS_REPORT_ES_MX } from "./bonus-report-es-mx";
